//
// Search store
//
// Stores location of geocoding result.
//

import { setViewport } from './map';

// ------------------------------------
// Action definitions
// ------------------------------------

export const SET_LOCATION = 'SEARCH/SET';
export const RESET = 'SEARCH/RESET';

// ------------------------------------
// Action creators
// ------------------------------------

export const setLocation = location => ({
  type: SET_LOCATION,
  location
});

export const reset = () => ({
  type: RESET
});

export const zoomTo = location => dispatch => {
  const { coordinates } = location.geometry;
  const center = [ coordinates[1], coordinates[0] ];
  dispatch(setLocation(location));
  dispatch(setViewport({ center, zoom: 16 }))
};

// ------------------------------------
// Initial state
// ------------------------------------

const initialState = {
  location: null
};

// ------------------------------------
// Reducer
// ------------------------------------

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_LOCATION:
      return {
        location: action.location
      };

    case RESET:
      return {
        location: null
      };

    default:
      return state
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/search.js